var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.451 6.36216C17.4277 6.30496 15.1415 0.5 9.07555 0.5C9.05042 0.5 9.02528 0.502813 9.00015 0.504688C8.97502 0.501875 8.94989 0.5 8.92476 0.5C2.85885 0.5 0.56995 6.30215 0.549269 6.36216C0.482847 6.5375 0.482847 6.73441 0.553757 6.90692C0.645313 7.13477 2.86771 12.5 8.92488 12.5H9.07657C15.1363 12.5 17.3578 7.13472 17.4477 6.90692C17.5159 6.73346 17.5177 6.53655 17.4513 6.36216H17.451ZM9.07279 11.0587H8.9211C4.45635 11.0587 2.44135 7.63075 1.94501 6.62092C2.4342 5.56982 4.45198 1.94022 8.9211 1.94022C8.94623 1.94022 8.97136 1.9374 8.99649 1.93553C9.02163 1.93834 9.04676 1.94022 9.07189 1.94022C13.5438 1.94022 15.5588 5.5698 16.048 6.62092C15.5534 7.63358 13.5355 11.0587 9.07279 11.0587Z",
    fill: "#20C3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99826 3.14062C7.22458 3.14062 5.78125 4.64834 5.78125 6.50113C5.78125 8.35392 7.22458 9.86163 8.99826 9.86163C10.7719 9.86163 12.2153 8.35392 12.2153 6.50113C12.2153 4.64834 10.7719 3.14062 8.99826 3.14062ZM8.99826 8.42142C7.98486 8.42142 7.15997 7.55974 7.15997 6.50113C7.15997 5.44252 7.98486 4.58084 8.99826 4.58084C10.0117 4.58084 10.8366 5.44252 10.8366 6.50113C10.8366 7.55974 10.0117 8.42142 8.99826 8.42142Z",
    fill: "#20C3FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewEyeIcon);
export default __webpack_public_path__ + "static/media/viewEyeIcon.74ea57c66005dae374ee9d0087888bf0.svg";
export { ForwardRef as ReactComponent };